import {defineStore} from 'pinia';
import {getStorage, saveStorage} from '~/composables/UseStorage';

export const useThemeStore = defineStore('theme', {
    state: () => ({
        isDarkMode: false,
        adminViewMode: 'employer' as 'employer' | 'dealer'
    }),
    actions: {
        initTheme() {
            // Check if running on client side
            if (typeof window !== 'undefined') {
                // Load saved theme preference
                const savedTheme = getStorage(useRuntimeConfig().public.storageKeys.theme);

                if (savedTheme && typeof savedTheme.isDarkMode === 'boolean') {
                    this.isDarkMode = savedTheme.isDarkMode;
                } else {
                    // Check system preference
                    this.isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
                }

                // Load saved view mode
                if (savedTheme && savedTheme.adminViewMode) {
                    this.adminViewMode = savedTheme.adminViewMode;
                }

                // Apply the theme
                this.applyTheme();

                // Listen for system theme changes
                window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
                    if (!getStorage(useRuntimeConfig().public.storageKeys.theme)) {
                        this.isDarkMode = e.matches;
                        this.applyTheme();
                    }
                });
            }
        },

        toggleDarkMode() {
            this.isDarkMode = !this.isDarkMode;
            this.applyTheme();
            this.saveTheme();
        },

        setDarkMode(value: boolean) {
            this.isDarkMode = value;
            this.applyTheme();
            this.saveTheme();
        },

        setAdminViewMode(view: 'employer' | 'dealer') {
            this.adminViewMode = view;
            this.saveTheme();
        },

        applyTheme() {
            if (this.adminViewMode === 'dealer' && typeof window !== 'undefined') {
                document.documentElement.classList.remove('dark');
            } else {
                if (typeof window !== 'undefined') {
                    if (this.isDarkMode) {
                        document.documentElement.classList.add('dark');
                    } else {
                        document.documentElement.classList.remove('dark');
                    }
                }
            }
        },

        saveTheme() {
            saveStorage(useRuntimeConfig().public.storageKeys.theme, {
                isDarkMode: this.isDarkMode,
                adminViewMode: this.adminViewMode
            });
        }
    }
});
